module.exports = "/static-assets/_next/static/images/img-5a01b08903-bf4ff9cf9c996f078dcd4a8454e98cd6.webp";